// extracted by mini-css-extract-plugin
export default {"productDescription":"z--z","featuredDescription":"A--z","description":"B--z","more":"C--z","descriptionSku":"D--z"};